import React from 'react';
import ModalSkeleton from '../ModalSkeleton';
import classes from './AgentsMoreFiltersModal.module.css';
import { Col, Row } from 'react-bootstrap';
import Button from '../../Component/Button/Button';

const AgentsMoreFiltersModal = ({ show, setShow, children, onApply }) => {
  return (
    <ModalSkeleton width={'600px'} show={show} setShow={setShow} modalClass={classes.modal}>
      <Row className={classes.row}>
        {children}
        <Col md={12}>
          <Button
            className={classes.btn}
            onClick={() => {
              onApply && onApply();
              setShow(false);
            }}>
            Apply
          </Button>
        </Col>
      </Row>
    </ModalSkeleton>
  );
};

export default AgentsMoreFiltersModal;
